import { render, staticRenderFns } from "./TenantIndustrySetting.vue?vue&type=template&id=2fd5f438"
import script from "./TenantIndustrySetting.vue?vue&type=script&lang=js"
export * from "./TenantIndustrySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports